import { render, staticRenderFns } from "./ChangeStatusTable.vue?vue&type=template&id=553e4378&scoped=true&"
import script from "./ChangeStatusTable.vue?vue&type=script&lang=js&"
export * from "./ChangeStatusTable.vue?vue&type=script&lang=js&"
import style0 from "./ChangeStatusTable.vue?vue&type=style&index=0&id=553e4378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e4378",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
